module.exports = __webpack_public_path__ + "0b25ca4c86c6656c4f21e06905b3cc7f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-2.png
// module id = 1770
// module chunks = 0